import React from 'react';
import styled from 'styled-components';
import Fonts from '../../../ui/global/Fonts';
import Colors from '../../../ui/global/Colors';

const PlanRoot = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 4px;
    font-family: ${Fonts.lexendSemiLight.fontFamily};
    font-weight: ${Fonts.lexendSemiLight.fontWeight};
    font-size: 18px;
    line-height: 1.2em;
    color: ${Colors.white};
    padding: 20px;
    margin: 10px;
    overflow-y: auto;
    overflow-x: hidden;
`;

interface GamePlanProps {
    content: string;
}

const getStatusEmoji = (status) => {
    switch(status) {
      case "PENDING":
        return "🏗️";
      case "DONE":
        return "✅";
      case "WAITING":
        return "⏳";
      default:
        return "⏳";
    }
};

const GamePlan = ({ content }: GamePlanProps) => {
    
    const data = content ? JSON.parse(content) : { status: "Waiting...", plan: []}
    // console.log("Plan component data", { data, isStreaming });

    return (
        <PlanRoot>
            <h1>{"Loading..."}</h1>
            <ul>
                {data.plan.map((item, index) => (
                    <li key={index} style={{ marginBottom: 10}}>
                        <span>{getStatusEmoji(item.status)} </span>
                        <span>{item.task} [{item.friendly}] ({item.priority})</span>
                    </li>
                ))}
            </ul>
        </PlanRoot>
    );
};

export default GamePlan;